import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useEffect, useState } from "react";
import { externalLinks, nav } from "../../../utils/siteContent";
import { StyledHeader } from "../../styled/header";
import { StyledLayout } from "../../styled/layout";
import Logo from "../logo/logo";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <StyledHeader.Root scrolled={scrolled}>
        <StyledLayout.Container>
        <StyledHeader.Inner>
          <a href="#inicio" aria-label="Access Informática — Inicio">
            <Logo />
          </a>

          <StyledHeader.Links aria-label="Principal">
            {nav.map((item) => (
              <StyledHeader.Link key={item.href} href={item.href}>
                {item.label}
              </StyledHeader.Link>
            ))}
          </StyledHeader.Links>

          <StyledHeader.Actions>
            <StyledHeader.Login
              href={externalLinks.clientAccess}
              target="_blank"
              rel="noopener noreferrer">
              Clientes <OpenInNewIcon />
            </StyledHeader.Login>
            <StyledHeader.Login
              href={externalLinks.mlPoint}
              target="_blank"
              rel="noopener noreferrer">
              ML Point <OpenInNewIcon />
            </StyledHeader.Login>
            <StyledHeader.Burger
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={open}>
              {open ? <CloseIcon /> : <MenuIcon />}
            </StyledHeader.Burger>
          </StyledHeader.Actions>
        </StyledHeader.Inner>
        </StyledLayout.Container>
      </StyledHeader.Root>

      {/* Menú mobile — fuera del <header> para que quede fixed respecto al
          viewport y no lo afecte el backdrop-filter del header al scrollear. */}
      <StyledHeader.Drawer open={open}>
        <StyledHeader.DrawerLinks>
          {nav.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
          <a
            href={externalLinks.clientAccess}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}>
            Clientes <OpenInNewIcon />
          </a>
          <a
            href={externalLinks.mlPoint}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}>
            ML Point <OpenInNewIcon />
          </a>
        </StyledHeader.DrawerLinks>
      </StyledHeader.Drawer>
    </>
  );
};

export default Header;
